import { render, staticRenderFns } from "./customsetting.vue?vue&type=template&id=66cc4efe&"
import script from "./customsetting.vue?vue&type=script&lang=js&"
export * from "./customsetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports